import differenceInYears from 'date-fns/differenceInYears';
import Profile from './profile';

export default class CertificateProfile extends Profile {
  constructor(profile, url) {
    super(profile, url);

    this.address = profile?.address || null;
    this.first_name = profile?.first_name || '';
    this.last_name = profile?.last_name || '';
    this.middle_name = profile?.middle_name || '';
    this.email = profile?.email || null;
    this.email_verified_at = profile?.email_verified_at || '';
    this.phone = profile?.phone || null;
    this.caption = profile?.caption || null;
    this.birthday_at = profile?.birthday_at || null;
    this.snils = profile?.snils || null;

    this.options = profile.options || {}; // { class: '8' },

    this.name =
      (profile?.name || [profile?.last_name, profile?.first_name, profile?.middle_name].join(' ')).trim() || 'Пользователь не указал ФИО';
  }

  get age() {
    const { birthday_at } = this;

    if (!birthday_at) {
      return 'Возраст отсутствует';
    }

    const currentDate = new Date();
    const birthdayDate = new Date(birthday_at);

    return differenceInYears(currentDate, birthdayDate) || 'Неверно указан возраст';
  }
}
